import React from 'react';

import styled from '@emotion/styled';
import { mq, fontEn, text, red01 } from '../../_style';

const Container = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding-top: 45px;

  ${mq.pc} {
    width: calc((100% - 39px * 3) / 4);
    &:not(:nth-of-type(4n)):not(:last-of-type) {
      margin-right: 39px;
    }
    &:not(:nth-of-type(-n + 4)) {
      padding-top: 60px;
    }
  }

  ${mq.sp} {
    width: calc((100% - 18px) / 2);
    &:not(:nth-of-type(2n)) {
      margin-right: 18px;
    }
  }

  .a-image {
    ${mq.sp} {
      margin-bottom: 10px;
    }
  }
  & > div {
    & > h6 {
      font-weight: bold;
      ${text('16px', 24 / 16)}
      padding-bottom: 15px;
      ${mq.sp} {
        ${text('14px', 22 / 14)}
      }
    }
    & > p {
      padding-top: 15px;
      padding-bottom: 20px;
      ${text('14px', 22 / 14)}
      ${mq.sp} {
        ${text('12px', 36 / 24)}
      }
    }
  }
  &.is-new {
    &::before {
      content: 'NEW';
      position: absolute;
      left: 10px;
      top: 40px;
      color: ${red01};
      font-family: ${fontEn};
      font-size: 14px;
      line-height: 1;
      letter-spacing: 0.2em;
      ${mq.sp} {
        left: 10px;
        top: 38px;
      }
    }
  }
`;

export default class ProductItem extends React.Component {
  render() {
    return (
      <Container className={this.props.isNew ? 'is-new' : null}>
        {this.props.children}
      </Container>
    );
  }
}
